import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { reconClient } from '../../../utils/axios';

// GET /api/v1/kpis — current dbt snapshot's KPI header: summary cards
// (total_documents / gross_value / vat_payable / health_percent), per-
// classification counts, and snapshot freshness.
export const fetchKpis = async ({ queryKey }) => {
  const [, params] = queryKey;
  const { data } = await reconClient.get('/kpis', { params, skipErrorSnackbar: true });
  return data;
};

export const useGetKpisHandler = ({ queryParams = {}, enabled = true } = {}) => {
  const dispatch = useDispatch();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['recon-kpis', queryParams],
    queryFn: fetchKpis,
    enabled,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
  });

  useEffect(() => {
    if (isError) {
      const message = error?.response?.data?.detail ?? error?.message ?? 'Failed to load reconciliation KPIs';
      dispatch(showSnackbar({ message, severity: 'error' }));
    }
  }, [dispatch, error, isError]);

  return { kpis: data, isLoading };
};
